<template lang="pug">

.le(v-if="!isUpcoming")
	Loading(v-show="initialFail")
	transition(name='fade')
		.ge-head_team-wrap(v-show="isLeadersReady")
			.ge-head_team.ge-head_team--local
				img.ge-head_team__img(:src="$store.state.match.localImage", :alt="$store.state.match.localShortName")
				span.ge-head_team__name {{ $store.state.match.localShortName }}
			NavQuarter
			.ge-head_team.ge-head_team--visitor
				img.ge-head_team__img(:src="$store.state.match.visitorImage", :alt="$store.state.match.visitorShortName")
				span.ge-head_team__name {{ $store.state.match.visitorShortName }}
	Loading(v-if="userRequestFail")
	transition(name="fade")
		.do-wrap(v-if="!userRequestFail && loaded" v-show="isLeadersReady")
			LeadersStat(:stat = "val" :key="'val.leaders'")
			LeadersStat(:stat = "score" :key="'score.leaders'")
			img.le-sponsor(v-if="val" src="/acb-logo.png", alt="acb")
			LeadersStat(:stat = "rb" :key="'rb.leaders'")
			LeadersStat(:stat = "asis" :key="'asis.leaders'")
			img.le-sponsor(v-if="val" src="/acb-logo.png", alt="acb")

</template>

<style lang="sass">

.le
	display: grid
	grid-auto-flow: row
	justify-items: center
	grid-gap: 4rem
	flex-direction: column
	align-items: center
	padding: 4rem 1rem
		bottom: 16rem
	&-sponsor
		max-height: 50px

</style>

<script>

import api from "@/api/index.js"

import NavQuarter from "@/components/subcomponents/nav/NavQuarter.vue"
import LeadersStat from "@/components/subcomponents/leaders/LeadersStat.vue"
import Loading from "@/components/subcomponents/general/Loading.vue"

export default {
	name: "Leaders",
	data()  {
		return {
			loaded: false,
			val: {},
			score: {},
			rb: {},
			asis: {},
			userRequestFail: false,
			timer: null,
			initialFail: false,
			initialTimer: null
		}
	},
	computed: {
		isLeadersReady() {
			return this.$store.state.general.isLeadersReady
		},
		actual() {
			return this.$store.state.general.actual
		},
		refreshSignal() {
			return this.$store.state.general.refreshSignal
		},
		period() {
			return this.$store.state.match.selQuarter
		},
		isUpcoming() {
			return this.$store.state.match.status == 'upcoming'
		},
	},
	methods: {
		updateLeaders() {
			api.match.getLeaders(this.$route.params.id_match,this.period)
			.then((data) => {
				this.$data.val = data.val
				this.$data.score = data.score
				this.$data.rb = data.rb
				this.$data.asis = data.asis
				this.$data.loaded = true
				this.clearInitialTimer()
				this.clearTimer()
				this.$store.commit('general/setLeadersReady',true)
				}
			)	
		},
		setTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.userRequestFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearTimer() {
			if (this.timer) {
				this.$data.userRequestFail = false
				this.$data.initialFail = false
				clearTimeout(this.timer)
			}
		},
		setInitialTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.initialFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearInitialTimer() {
			if (this.initialTimer) {
				this.$data.initialFail = false
				clearTimeout(this.initialTimer)
			}
		},
	},
	watch: {
		actual: {
			handler: function () {
				this.updateLeaders()
			},
        deep: true
		},
		period() {
			this.setTimer()
			this.updateLeaders()
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing)
					this.updateLeaders()
			}
		}
	},
	created() {
		if (this.actual.competition && this.actual.edition)
			this.updateLeaders()
		this.setInitialTimer()
		this.$data.loaded = false
	},
	mounted() {
		this.$store.commit('general/setLeadersReady',false)
		this.$parent.goTop()
	},
	components: {
		NavQuarter,
		Loading,
		LeadersStat,
	},
}

</script>